import { connect } from 'react-redux';
import { compose, withProps, flattenProp } from 'recompose';
import { withFirebase, withFirestore } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { loadRelevantUploads } from '../../../store/actions/youtubeActions';
import { get5MostRecentUploads } from '../../../store/selectors/youtube';
import { getActiveCampaigns } from '../../../store/selectors/campaigns';
import {
  getDealList,
  getActiveDealsCount,
  getPendingContentApprovalCount,
  getPendingDealsCount,
  getPendingMatchesForCompanyCount,
  getWaitingForEscrowCount
} from '../../../store/selectors/deals';
import { loadRelevantInfluencers } from '../../../store/actions/influencerActions';
import {
  addProduct,
  removeProduct
} from '../../../store/actions/productActions';
import { CompanyInterestedFromDashboard } from '../../../store/actions/dealActions';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary,
  primary
} from '../../../style';

const styles = theme => ({
  dashboardContainer: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  title: {
    color: deepPurple,
    marginBottom: '30px'
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  dealItem: {
    width: '200px',
    height: '250px',
    backgroundColor: '#F3F3F3',
    marginRight: '10px'
  },
  relevantInfluencersContainer: {
    marginRight: '15px'
  },
  influencerItem: {
    width: '200px',
    height: '250px'
  },
  influencerListMiddle: {
    height: '75%'
  },
  influencerListBottom: {
    backgroundColor: '#5DBE76',
    cursor: 'pointer'
  },
  influencerContentContainer: {
    height: '100%'
  },
  influencerContentTop: {
    height: '40%'
  },
  influencerContentMiddle: {
    height: '20%'
  },
  influencerContentBottom: {
    height: '40%'
  },
  profilePicture: {
    height: '96px',
    width: '96px',
    '& > img': {
      borderRadius: '50%',
      height: '100%',
      width: '100%'
    }
  },
  newProductContainer: {
    minHeight: '350px'
    // backgroundColor: '#F3F3F3'
  },
  carouselItem: {
    width: '250px',
    height: '250px',
    minWidth: '250px',
    background: 'white',
    cursor: 'pointer'
  },
  productCarouselItem: {
    objectFit: 'cover',
    background: 'white',
    position: 'relative',
    overflow: 'hidden'
  },
  carouselTop: {
    height: '200px'
  },
  carouselBottom: {
    position: 'absolute',
    height: '50px',
    width: '100%',
    zIndex: '100',
    background: 'black',
    opacity: '.65',
    color: 'white',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  carouselBottomImage: {
    width: '100%',
    objectFit: 'cover'
  },
  completedDealContainer: {
    background: 'white',
    height: '75px',
    width: '100%',
    marginBottom: '4px'
  },
  card: {
    height: '100%'
  },
  cardContent: {
    textAlign: 'center',
    '& > *': {
      marginTop: '10px',
      marginBottom: '10px'
    }
  },
  suggestCardActions: {
    padding: 0
  },
  cardIcon: {
    backgroundColor: 'rgba(34, 194, 110, 0.08)',
    cursor: 'initial'
  },
  suggestCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  suggestCardHeader: {
    backgroundColor: '#F3F3F3',
    minHeight: '50px'
  },
  suggestCardContent: {
    height: '100%'
  },
  youtubeIcon: {
    color: white,
    width: '25px',
    height: '25px'
  },
  requestText: {
    color: white,
    paddingTop: 10,
    paddingBottom: 10
  },
  add: {
    color: white
  },
  subTitle: {
    marginBottom: 20
  },
  interest: {
    height: '32px',
    overflow: 'hidden'
  },
  carousel: {
    margin: '2px'
  },
  removeButton: {
    position: 'absolute',
    height: '50px',
    zIndex: '1000',
    bottom: 0,
    right: '10px',
    color: 'white',
    cursor: 'pointer'
  },
  newCampaignButton: {
    backgroundColor: primary,
    color: 'white'
  },
  newCampaignButtonContainer: {
    marginLeft: '32px',
    marginTop: '64px'
  },
  campaignItemLeftContainer: {
    width: '180px',
    float: 'left',
    display: 'inline-block',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  campaignItemRightContainer: {
    display: 'inline-block'
  },
  campaignItemContainer: {
    minHeight: '200px',
    width: '100%',
    marginLeft: '32px',
    marginRight: '32px',
    marginTop: '32px'
  },
  campaignItemTitle: {
    marginBottom: '15px'
  },
  campaignStatContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '120px',
    height: '120px',
    marginRight: '15px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#22c26e',
      color: 'white !important',
      '& h6': {
        color: 'white'
      }
    },
    '& h6': {
      color: '#22c26e'
    }
  },
  totalViews: {
    marginBottom: '10px',
    marginTop: '10px'
  },
  campaignItemButtons: {
    display: 'inline-flex',
    flexDirection: 'column',
    width: '300px'
  },
  campaignItemButton: {
    float: 'right',
    border: '1px solid #22c26e',
    color: '#22c26e'
  },
  campaignItemButtonUpper: {
    float: 'right',
    border: '1px solid #22c26e',
    color: '#22c26e',
    marginBottom: '20px'
  },
  campaignItem: {
    paddingBottom: '40px'
  },
  activeCampaignsContainer: {
    height: '100px',
    background: '#F5F6FA',
    display: 'flex',
    alignItems: 'center'
  },
  activeCampaignsTitle: {
    margin: '15px'
  },
  activeCampaignContainer: {
    padding: '15px'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    youtubeUploads: get5MostRecentUploads(state),
    dealList: getDealList(state),
    campaignList: getActiveCampaigns(state),
    activeDealsCount: getActiveDealsCount(state),
    pendingContentApprovalCount: getPendingContentApprovalCount(state),
    pendingMatchesCount: getPendingMatchesForCompanyCount(state),
    pendingEscrowCount: getWaitingForEscrowCount(state),
    relevantInfluencers: state.relevantInfluencers
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadRelevantYoutubeUploads: companyId =>
      dispatch(loadRelevantUploads(companyId)),
    loadRelevantInfluencersHandler: () => dispatch(loadRelevantInfluencers()),
    addProductHandler: (userId, newProduct) =>
      dispatch(addProduct(userId, newProduct)),
    CompanyMatchRequestHandler: (influencerId, companyId, campaignId) =>
      dispatch(
        CompanyInterestedFromDashboard(influencerId, companyId, campaignId)
      ),
    removeProductHandler: (userId, product) =>
      dispatch(removeProduct(userId, product))
  };
};

export default compose(
  // Map redux state to props
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  withFirebase,
  withFirestore,
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  // Flatten profile so that avatarUrl and displayName are props
  flattenProp('profile'),
  // Add styles as classes prop
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/CompanyDashboard.enhancer.js